import { createElement as _createElement } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
import { useDataAttributes } from '@bluebeam/react-hooks';
import { Listbox } from '@bluebeam/react-skyline-listbox';
import { useMenu } from '@react-aria/menu';
import { useTreeState } from '@react-stately/tree';
import { useRef } from 'react';
import MenuDivider, { ReactAriaMenuDivider } from './MenuDivider';
import MenuItem, { ReactAriaMenuItem } from './MenuItem';
import MenuPopover from './MenuPopover';
/**
 * A Menu is a type of **molecule** and represents a list of available
 * actions to perform.
 */
const Menu = (props) => {
    const state = useTreeState({
        children: props.children,
        disabledKeys: props.disabledKeys,
    });
    const menuRef = useRef();
    const { menuProps } = useMenu(props, state, menuRef);
    const dataAttributes = useDataAttributes(props);
    return (_jsx(MenuPopover, { anchorPoint: props.anchorPoint, isOpen: true, offset: 8, onClose: props.onClose, minWidth: props.minWidth, placement: props.placement && !props.anchorPoint ? props.placement : undefined, targetRef: props.triggerRef, width: props.width, children: _jsx(Listbox, { ...menuProps, ref: menuRef, ...dataAttributes, role: "menu", children: [...state.collection].map((item) => {
                if (item.type === 'separator') {
                    return _jsx(MenuDivider, {}, item.key);
                }
                if (item.type === 'item') {
                    return _createElement(MenuItem, { ...item.props, key: item.key, state: state, value: item.key });
                }
                return null;
            }) }) }));
};
Menu.Divider = ReactAriaMenuDivider;
Menu.Item = ReactAriaMenuItem;
export default Menu;
//# sourceMappingURL=Menu.js.map